// Fondations internationalisation (P2) — pays (ISO 3166-1 alpha-2) + fuseaux IANA.
// Les noms de pays et la liste complète des fuseaux sont fournis par l'API Intl du navigateur,
// afin d'éviter d'embarquer de volumineux jeux de données. La table pays → fuseaux provient de
// la base IANA (zone.tab) et conserve les désignations lisibles (ex. America/Guadeloupe, Indian/Reunion).
import COUNTRY_TIMEZONES from "../data/countryTimezones.json";

let _regionNames = null;
function regionNames() {
  if (_regionNames === null) {
    try {
      _regionNames = new Intl.DisplayNames(["fr"], { type: "region" });
    } catch (e) {
      _regionNames = false;
    }
  }
  return _regionNames;
}

export function countryName(code) {
  const rn = regionNames();
  if (rn) {
    try {
      const n = rn.of(code);
      if (n && n !== code) return n;
    } catch (e) {
      /* ignore */
    }
  }
  return code;
}

// Décalage UTC courant d'un fuseau — reflète automatiquement l'heure d'été/hiver en cours.
export function tzOffset(tz) {
  try {
    const dtf = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "longOffset" });
    const part = dtf.formatToParts(new Date()).find((p) => p.type === "timeZoneName");
    if (part && part.value) return part.value.replace("GMT", "UTC");
  } catch (e) {
    /* ignore */
  }
  return "UTC";
}

export function tzCity(tz) {
  const seg = (tz.split("/").pop() || tz).replace(/_/g, " ");
  return seg;
}

export function tzLabel(tz) {
  return `${tzCity(tz)} (${tzOffset(tz)})`;
}

// Liste mondiale des pays/territoires, triée par nom français.
export function countryOptions() {
  return Object.keys(COUNTRY_TIMEZONES)
    .map((code) => ({ value: code, label: countryName(code), sublabel: code }))
    .sort((a, b) => a.label.localeCompare(b.label, "fr"));
}

// Fuseaux proposés pour un pays donné (peut en contenir plusieurs, ex. États-Unis).
export function suggestedZones(code) {
  return (COUNTRY_TIMEZONES[code] || []).slice();
}

let _allZones = null;
function allZones() {
  if (_allZones === null) {
    let zones = [];
    try {
      if (typeof Intl.supportedValuesOf === "function") {
        zones = Intl.supportedValuesOf("timeZone");
      }
    } catch (e) {
      /* ignore */
    }
    if (!zones || zones.length === 0) {
      const set = new Set();
      Object.values(COUNTRY_TIMEZONES).forEach((arr) => arr.forEach((z) => set.add(z)));
      set.add("UTC");
      zones = Array.from(set);
    }
    _allZones = zones.slice().sort();
  }
  return _allZones;
}

// Options de fuseau : groupe « Suggérés » (selon le pays) puis « Tous les fuseaux ».
export function timezoneOptions(countryCode) {
  const suggested = suggestedZones(countryCode);
  const out = [];
  suggested.forEach((tz) =>
    out.push({ value: tz, label: tzLabel(tz), sublabel: tz, group: "Suggérés pour ce pays" }),
  );
  allZones().forEach((tz) => {
    if (!suggested.includes(tz)) out.push({ value: tz, label: tzLabel(tz), sublabel: tz, group: "Tous les fuseaux" });
  });
  return out;
}
